/*
 * ${locale}.resources.${resourceName}.name for resource names (used for the menu and page titles)
 * ${ locale }.resources.${ resourceName }.fields.${ fieldName } for field names(used for datagrid header and form input labels)
 */

export default {
    'unauthorised-action': 'Ceci est une action non autorisée',
    actions: {
        add: 'Ajouter',
        cancel: 'Annuler',
        close: 'Fermer',
        create: 'Créer',
        configure: 'Configurer',
        confirm: 'Confirmer',
        deduct: 'Déduire',
        delete: 'Effacer',
        duplicate: 'Dupliquer',
        edit: 'Modifier',
        export: 'Exporter',
        generated: 'Généré',
        goBack: 'Retour',
        hide: 'Cacher',
        import: 'Importer',
        invite: 'Inviter',
        list: 'liste',
        no: 'Non',
        ok: 'Ok',
        pause: 'Pause',
        refresh: 'Mise à jour',
        refund: 'Remboursement',
        reset: 'Effacer les valeurs',
        resume: 'Reprendre',
        retry: 'Recommencez',
        returnTo: 'Retourner à',
        returnToThe: 'Retour au',
        save: 'Sauvegarder',
        search: 'Chercher',
        show: 'Montrer',
        signIn: 'se connecter',
        submit: 'Soumettre',
        submit_add_another: 'Enregistrer et ajouter suivant',
        terminate: 'Terminer',
        translate: 'Traduire',
        yes: 'Oui',
    },
    auth: {
        forgotPassword: {
            actions: {
                iRemember: 'Je me souviens',
                resetPassword: 'Réinitialiser le mot de passe',
            },
            fields: {
                email: 'E-mail',
            },
            notifications: {
                success: 'Si nous pouvions trouver votre compte, vous recevrez un email sous peu.',
            },
            title: 'Mot de passe oublié?',
        },
        login: {
            fields: {
                email: 'E-mail',
                password: 'Mot de passe',
            },
            notifications: {
                failure: 'les informations d’identification invalides',
            },
            noCookies: {
                description: 'Les cookies ne sont pas activés sur votre navigateur. Veuillez activer les cookies dans les préférences de votre navigateur pour continuer.',
                title: 'Cookies nécessaires',
            },
        },
        logout: {
            description: 'Êtes-vous sûr de vouloir vous déconnecter?',
            title: 'Se déconnecter',
            notifications: {
                failure: 'Votre compte n’a pas pu être déconnecté.',
                success: 'Votre compte a été déconnecté avec succès',
            },
        },
    },
    components: {
        autocomplete: {
            hinttext: 'Tapez pour commencer la recherche',
        },
    },
    countries: {
        AD: 'Andorre',
        AE: 'Emirats Arabes Unis',
        AF: 'Afghanistan',
        AG: 'Antigua-et-Barbuda',
        AI: 'Anguilla',
        AL: 'Albanie',
        AM: 'Arménie',
        AO: 'Angola',
        AQ: 'Antarctique',
        AR: 'Argentine',
        AS: 'Samoa américaines',
        AT: 'L’Autriche',
        AU: 'Australie',
        AW: 'Aruba',
        AX: 'Iles Aland',
        AZ: 'Azerbaïdjan',
        BA: 'Bosnie Herzégovine',
        BB: 'Barbade',
        BD: 'Bangladesh',
        BE: 'Belgique',
        BF: 'Burkina Faso',
        BG: 'Bulgarie',
        BH: 'Bahrein',
        BI: 'Burundi',
        BJ: 'Bénin',
        BL: 'Saint Barthélemy',
        BM: 'Bermudes',
        BN: 'Brunei',
        BO: 'Bolivie',
        BQ: 'Bonaire, Saint-Eustache et Saba',
        BR: 'Brésil',
        BS: 'Bahamas',
        BT: 'Bhoutan',
        BV: 'Île Bouvet',
        BW: 'Botswana',
        BY: 'Biélorussie',
        BZ: 'Belize',
        CA: 'Canada',
        CC: 'Îles Cocos',
        CD: 'République Démocratique du Congo',
        CF: 'République centrafricaine',
        CG: 'République du Congo',
        CH: 'Suisse',
        CI: 'Côte d’Ivoire',
        CK: 'les Îles Cook',
        CL: 'Chili',
        CM: 'Cameroun',
        CN: 'Chine',
        CO: 'Colombie',
        CR: 'Costa Rica',
        CU: 'Cuba',
        CV: 'Cap-Vert',
        CW: 'Curacao',
        CX: 'L’île de noël',
        CY: 'Chypre',
        CZ: 'République Tchèque',
        DE: 'Allemagne',
        DJ: 'Djibouti',
        DK: 'Danemark',
        DM: 'La Dominique',
        DO: 'République Dominicaine',
        DZ: 'Algérie',
        EC: 'Équateur',
        EE: 'Estonie',
        EG: 'Egypte',
        EH: 'Sahara occidental',
        ER: 'Erythrée',
        ES: 'Espagne',
        ET: 'Ethiopie',
        FI: 'Finlande',
        FJ: 'Fidji',
        FK: 'les îles Falkland',
        FM: 'Micronésie',
        FO: 'Îles Féroé',
        FR: 'France',
        GA: 'Gabon',
        GB: 'Royaume-Uni',
        GD: 'Grenade',
        GE: 'Géorgie',
        GF: 'Guyane Française',
        GG: 'Guernesey',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GL: 'Groenland',
        GM: 'Gambie',
        GN: 'Guinée',
        GP: 'Guadeloupe',
        GQ: 'Guinée Équatoriale',
        GR: 'Grèce',
        GS: 'Géorgie du Sud et les îles Sandwich du Sud',
        GT: 'Guatemala',
        GU: 'Guam',
        GW: 'Guinée Bissau',
        GY: 'Guyane',
        HK: 'Hong Kong',
        HM: 'Îles Heard et McDonald',
        HN: 'Honduras',
        HR: 'Croatie',
        HT: 'Haïti',
        HU: 'Hongrie',
        ID: 'Indonésie',
        IE: 'Irlande',
        IL: 'Israël',
        IM: 'Île de man',
        IN: 'Inde',
        IO: 'Territoire britannique de l’océan Indien',
        IQ: 'Irak',
        IR: 'J’ai couru',
        IS: 'Islande',
        IT: 'Italie',
        JE: 'Jersey',
        JM: 'Jamaïque',
        JO: 'Jordan',
        JP: 'Japon',
        KE: 'Kenya',
        KG: 'Kirghizistan',
        KH: 'Cambodge',
        KI: 'Kiribati',
        KM: 'Les Comores',
        KN: 'Saint-Christophe-et-Niévès',
        KP: 'Corée du Nord',
        KR: 'Corée du Sud',
        KW: 'Koweit',
        KY: 'Îles Caïmans',
        KZ: 'Kazakhstan',
        LA: 'Laos',
        LB: 'Liban',
        LC: 'Sainte-Lucie',
        LI: 'Liechtenstein',
        LK: 'Sri Lanka',
        LR: 'Libéria',
        LS: 'Lesotho',
        LT: 'Lituanie',
        LU: 'Luxembourg',
        LV: 'Lettonie',
        LY: 'Libye',
        MA: 'Maroc',
        MC: 'Monaco',
        MD: 'La Moldavie',
        ME: 'Monténégro',
        MF: 'Saint Martin',
        MG: 'Madagascar',
        MH: 'Iles Marshall',
        MK: 'Macédoine',
        ML: 'Mali',
        MM: 'Myanmar',
        MN: 'Mongolie',
        MO: 'Macao',
        MP: 'Îles Mariannes du Nord',
        MQ: 'Martinique',
        MR: 'Mauritanie',
        MS: 'Montserrat',
        MT: 'Malte',
        MU: 'Maurice',
        MV: 'Maldives',
        MW: 'Malawi',
        MX: 'Mexique',
        MY: 'Malaisie',
        MZ: 'Mozambique',
        NA: 'Namibie',
        NC: 'Nouvelle Calédonie',
        NE: 'Niger',
        NF: 'l’ile de Norfolk',
        NG: 'Nigeria',
        NI: 'Nicaragua',
        NL: 'Pays-Bas',
        NO: 'Norvège',
        NP: 'Népal',
        NR: 'Nauru',
        NU: 'Niue',
        NZ: 'Nouvelle-Zélande',
        OM: 'Oman',
        PA: 'Panama',
        PE: 'Pérou',
        PF: 'Polynésie française',
        PG: 'Papouasie Nouvelle Guinée',
        PH: 'Philippines',
        PK: 'Pakistan',
        PL: 'Pologne',
        PM: 'Saint-Pierre-et-Miquelon',
        PN: 'Pitcairn',
        PR: 'Porto Rico',
        PS: 'Territoire Palestinien',
        PT: 'le Portugal',
        PW: 'Palau',
        PY: 'Le Paraguay',
        QA: 'Qatar',
        RE: 'Réunion',
        RO: 'Roumanie',
        RS: 'Serbie',
        RU: 'Russie',
        RW: 'Rwanda',
        SA: 'Arabie Saoudite',
        SB: 'Les îles Salomon',
        SC: 'les Seychelles',
        SD: 'Soudan',
        SE: 'Suède',
        SG: 'Singapour',
        SH: 'Sainte Hélène',
        SI: 'La Slovénie',
        SJ: 'Svalbard et Jan Mayen',
        SK: 'Slovaquie',
        SL: 'Sierra Leone',
        SM: 'Saint Marin',
        SN: 'Sénégal',
        SO: 'Somalie',
        SR: 'Suriname',
        SS: 'Soudan du sud',
        ST: 'Sao Tomé et Principe',
        SV: 'Le Salvador',
        SX: 'Sint Maarten',
        SY: 'Syrie',
        SZ: 'Swaziland',
        TC: 'îles Turques-et-Caïques',
        TD: 'Tchad',
        TF: 'Terres Australes Françaises',
        TG: 'Aller',
        TH: 'Thaïlande',
        TJ: 'Tadjikistan',
        TK: 'Tokélaou',
        TL: 'Timor oriental',
        TM: 'Turkménistan',
        TN: 'Tunisie',
        TO: 'Tonga',
        TR: 'dinde',
        TT: 'Trinité-et-Tobago',
        TV: 'Tuvalu',
        TW: 'Taïwan',
        TZ: 'Tanzanie',
        UA: 'Ukraine',
        UG: 'Ouganda',
        UM: 'Îles mineures éloignées des États-Unis',
        US: 'États Unis',
        UY: 'Uruguay',
        UZ: 'Ouzbekistan',
        VA: 'Vatican',
        VC: 'Saint-Vincent-et-les-Grenadines',
        VE: 'Venezuela',
        VG: 'Îles Vierges britanniques',
        VI: 'Îles Vierges américaines',
        VN: 'Vietnam',
        VU: 'Vanuatu',
        WF: 'Wallis et Futuna',
        WS: 'Samoa',
        XK: 'Kosovo',
        YE: 'Yémen',
        YT: 'Mayotte',
        ZA: 'Afrique du Sud',
        ZM: 'Zambie',
        ZW: 'Zimbabwe',
    },
    elements: {
        confirm: {
            description: 'Vous ne pourrez plus modifier les produits d’abonnement après cette action.',
            title: 'Êtes-vous sûr de vouloir confirmer cet abonnement?',
        },
        delete: {
            description: 'L’élément sera supprimé définitivement. Cette action ne peut pas être annulée.',
            title: 'Êtes-vous sûr de vouloir supprimer ceci?',
        },
        outdatedBrowser: {
            description: 'Notre outil Dashboard ne prend pas en charge la version actuelle de votre navigateur. Pour une meilleure utilisation de ce site web, veuillez mettre à jour votre navigateur avec la dernière version.',
            linkText: 'Cliquez ici pour découvrir comment',
            title: 'Améliorez votre expérience de Dashboard!',
        },
        terminate: {
            description: 'L’abonnement sera définitivement résilié.',
            title: 'Êtes-vous sûr de vouloir mettre fin à cet abonnement?',
        },
    },
    export: {
        error: {
            maximum_reached: 'Mais nos exportations ne peuvent contenir plus de 15 000 réservations. Vous pouvez ajouter d’autres filtres pour réduire le nombre de réservations ou continuer et exporter les 15 000 premiers résultats.',
            title: 'Nous savions que vous avez réussi...',
        },
        description: 'Sélectionnez les champs que vous souhaitez voir dans votre exportation',
        notifications: {
            empty_filters: {
                description: 'Cela nécessite l’application d’un ou de plusieurs filtres. Appliquez un ou plusieurs filtres pour effectuer une exportation.',
                title: 'Il nous manque des filtres',
            },
        },
        title: 'Préparer l’exportation',
        field_groups: {
            booking: 'Les détails de réservation',
            consumer: 'Consommateur',
            customer: 'Détails du client',
            default: 'Défaut',
            financial: 'Détails financiers',
            payment_method: 'Mode de paiement',
            product: 'Produit',
            user_attributes: 'Attributs utilisateur',
        },
        fields: {
            administration_fee: {
                maximum: 'Maximum',
                maximum_placeholder: 'par ex. 1.99, 2.50',
                minimum: 'Minimum',
                minimum_placeholder: 'par ex. 1.99, 2.50',
                percentage: 'Pourcentage',
                percentage_placeholder: 'par ex. 0.10 (10%), 0.03 (3%)',
            },
            amount: 'Montant',
            arrival_date: 'Date d’arrivée',
            booking_date: 'Date de réservation',
            costfree_cancellation: 'Assurance annulation',
            currency: 'Devise',
            customer_email: 'Email client',
            customer_first_name: 'Prénom du client',
            customer_last_name: 'Nom du client',
            customer_license_plate: 'Plaque d’immatriculation client',
            customer_phone: 'Téléphone du client',
            customer_remarks: 'Remarques client',
            departure_date: 'Date de départ',
            discount_amount: 'Montant de la remise',
            discount_company_name: 'Nom de l’entreprise de remise',
            discount_owner_id: 'ID du propriétaire de la remise',
            discount_title: 'Nom de la remise',
            email: 'Email',
            first_name: 'Prénom',
            gateway: 'Passerelle',
            has_failed_invoice: 'La facture a échoué',
            id: 'ID',
            internal_order_id: 'numéro de commande',
            invoiced_at: 'Facturé à',
            last_name: 'Nom',
            locale: 'Langue',
            method: 'Méthode',
            number_of_persons: 'Nombre de personnes',
            options_price: 'Prix ​​des options',
            order_id: 'Numéro de commande',
            payment_amount_paid: 'Montant du paiement payé',
            payment_method: 'Payment method',
            payment_method_status: 'Payment method status',
            price_membership_deduction: 'Membership deduction',
            payment_status: 'Statut de paiement',
            phone: 'Numéro de téléphone',
            price: 'Prix',
            product_address: 'Adresse du produit',
            product_id: 'Identifiant du produit',
            product: 'Produit',
            provider_id: 'Identifiant du fournisseur',
            provider_price_total: 'Prix ​​total fournisseur',
            provider_price: 'Prix ​​du fournisseur',
            provider: 'Fournisseur',
            reseller_funnel: 'Entonnoir des revendeurs',
            reseller_id: 'Identifiant revendeur',
            reseller_price_total: 'Prix ​​total revendeur',
            reseller_price: 'Prix ​​revendeur',
            reseller: 'Revendeur',
            reservation_status: 'Statut de réservation',
            return_flight_number: 'Numéro de vol de retour',
            status: 'État',
            transaction_fee: 'Frais de transaction',
            yield_price: 'Prix ​​de rendement',
        },
    },
    fields: {
        currency: 'Devise',
        dates: 'Date',
        datetime: {
            never: 'Jamais',
        },
        empty: 'inconnu',
        ends_at: 'Se termine à',
        full: 'Complet',
        is_scheduled: 'Programmé',
        none: 'Aucun',
        optional: '(Facultatif)',
        other: 'Autre',
        percentage: 'Pourcentage',
        price: 'Prix',
        price_original: 'Prix d’origine',
        reason: 'Raison',
        size: 'Taille',
        starts_at: 'Commence à',
        updated: 'Mis à jour',
        weekday: {
            1: 'Lundi',
            2: 'Mardi',
            3: 'Mercredi',
            4: 'Jeudi',
            5: 'Vendredi',
            6: 'Samedi',
            7: 'Dimanche',
        },
    },
    forms: {
        email: 'Il doit s’agir d’un e-mail',
        error: {
            'location-not-found': 'L’emplacement n’a pas pu être trouvé',
            'location-could-not-be-resolved': 'L’emplacement n’a pas pu être trouvé',
            'the-id-format-is-invalid': 'Le format de l’identifiant n’est pas valide',
        },
        invalid: {
            discount_rule: 'Règle de réduction invalide',
            email: 'Email invalide',
            first_name: 'Prénom invalide',
            general: 'Caractères non reconnus',
            last_name: 'Nom invalide',
            match: 'The value with %{field} does not match',
            max_characters: 'Must be %{max} characters or less',
            phone: 'Ce numéro de téléphone n`est pas valide',
            url: 'Ceci est une URL invalide',
        },
        localisation: {
            available: {
                title: 'Ajouter une langue',
            },
            origin: {
                description: 'Souhaitez-vous traduire les textes actuels de %{locale} en %{target}?',
                title: 'Traduire en %{source}',
            },
            update: {
                description: 'Souhaitez-vous traduire les textes actuels de %{locale} en %{target}?',
                description_2: 'La traduction écrasera les textes %{target} actuels.',
                description_3: 'Ils ne sont enregistrés que lorsque vous soumettez le formulaire.',
                inactive: 'Veuillez ajouter le texte dans %{locale} avant de pouvoir traduire dans cette langue.',
                title: 'Tradurre in inglese',
            },
            required: {
                description: 'Il est obligatoire de saisir tous les textes en anglais avant de pouvoir ajouter d’autres langues.',
                title: 'Ajouter une langue',
            },
        },
        no_results: 'Aucune description n’a été ajoutée à ce produit.',
        number: 'Cela doit être un chiffre',
        one_of_them_required: 'Veuillez remplir un de ces champs.',
        required: 'Champs obligatoires',
        submit: {
            required: '%{locale} - %{key} est requis',
        },
    },
    filters: {
        add: 'Ajouter un filtre',
        category: {
            advanced: 'Avancée',
            basic: 'de base',
        },
        clear_all_filters: 'Effacer tous les filtres',
        components: {
            accountId: {
                label: 'Compte',
            },
            booking: {
                label: 'Réservation',
            },
            bookingOrderId: {
                label: 'ID de l’ordre de réservation',
            },
            bookingReservationOrderId: {
                label: 'Numéro de commande de réservation',
            },
            cancelled: {
                label: 'Annulé',
            },
            cancelledAt: {
                label: 'Annulé à',
                placeholder: 'Choisissez une date',
            },
            categoryId: {
                label: 'Catégorie',
                placeholder: 'Choisissez une catégorie',
            },
            companyName: {
                label: 'Nom de la société',
            },
            createdAt: {
                label: 'Créé à',
                placeholder: 'Choisissez une date',
            },
            currencies: {
                label: 'Devises',
                placeholder: 'Choisissez une devise',
            },
            destinationArrivalDate: {
                label: 'Date d’arrivée',
                placeholder: 'Début',
            },
            destinationDepartureDate: {
                label: 'Date de départ',
                placeholder: 'Fin',
            },
            email: {
                label: 'Email',
            },
            enabled: {
                choices: {
                    active: 'Seulement actif',
                    inactive: 'Seulement inactif',
                },
                label: 'Activée',
            },
            end_date_null_or_from: {
                label: 'Résilié depuis',
            },
            funnelId: {
                label: 'Campagnes',
            },
            interval: {
                choices: {
                    day: 'journée',
                    month: 'mois',
                    week: 'semaine',
                    year: 'année',
                },
                label: 'Interval',
            },
            invoice: {
                label: 'Facture',
            },
            is_rebooked: {
                choices: {
                    active: 'Uniquement rebooké',
                    inactive: 'Uniquement non rebooké',
                },
                label: 'Rebooké',
            },
            is_terminated: {
                label: 'Résilié',
            },
            lastName: {
                label: 'Nom de famille',
            },
            licensePlate: {
                label: 'Plaque d’immatriculation',
            },
            name: {
                label: 'Nom',
            },
            orderId: {
                label: 'Numéro de commande',
            },
            paymentStatus: {
                choices: {
                    chargedback: 'Rétrofacturation',
                    deferred: 'Différé',
                    failed: 'Echoué',
                    inProgress: 'En cours...',
                    refunded: 'Remboursé',
                    success: 'Réussi',
                    unknown: 'Inconnu',
                },
                label: 'Situation du Payement',
                placeholder: 'Sélectionnez votre paiement',
            },
            phone: {
                label: 'Numéro de téléphone',
            },
            pointOfInterestId: {
                label: 'Point d’intérêt',
            },
            productId: {
                label: 'Produit',
            },
            providerId: {
                label: 'Fournisseur',
            },
            resellerId: {
                label: 'Revendeur',
            },
            reservationStatus: {
                choices: {
                    awaiting: 'En attente',
                    canceled: 'Annulée',
                    completed: 'Completée',
                    error: 'Erreur',
                    pending: 'En Attente',
                    split: 'Se Séparer',
                    underReview: 'à l’étude',
                },
                label: 'Statut de la réservation',
            },
            subcategoryId: {
                label: 'Sous-catégorie',
                placeholder: 'Sous-catégorie',
            },
            status: {
                label: 'Statut',
            },
            testBooking: {
                choices: {
                    real: 'Seulement réel',
                    test: 'Test uniquement',
                },
                label: 'Type de réservation',
            },
            userId: {
                label: 'Utilisateur',
            },
            product_membership_id: {
                label: 'Adhésion au produit',
            },
            user_product_membership_pool_id: {
                label: 'Groupe d’adhésion au produit',
            },
            usesDiscountCodes: {
                choices: {
                    active: 'Utilisez des codes de réduction',
                    inactive: 'Pas de code de réduction',
                },
                label: 'Utilise des codes de réduction',
            },
        },
        title: 'Filtres',
        matchtype: 'Type de match',
        matchtypes: {
            between: 'Entre',
            contains: 'Contient',
            ends_with: 'Se termine par',
            equals: 'Équivaut à',
            match_all_of: 'Correspond à tous',
            match_one_of: 'Correspond à l’un des',
            near: 'Près',
            range: 'Dans',
            starts_with: 'Commence avec',
        },
    },
    general: {
        data_updated: 'Données mises à jour',
        error: 'Quelque chose c’est mal passé. Merci d’essayer plus tard...',
        images: 'Photos',
        loading: 'Chargement...',
        noMatches: 'Impossible de trouver des matchs',
    },
    impersonation: {
        actions: {
            log_in: 'Imiter',
            log_out: 'Retour à votre compte',
        },
        logged_in: 'Vous êtes actuellement connecté en tant que %{name}',
    },
    languages: {
        dutch: 'Néerlandais',
        english: 'Anglais',
        german: 'Allemand',
        french: 'Français',
        italian: 'Italien',
        spanish: 'Espanol',
    },
    localisations: {
        dialog: {
            label: 'Sélectionnez une langue disponible',
        },
    },
    dropzone: {
        label: {
            button: 'Téléchargez le logo',
            button_image: 'Télécharger une image',
            description_file_max: 'Taille de fichier max.: %{max} KB',
            description_max: 'Hauteur max.: %{height}px, Largeur max.: %{width}px',
            description_min: 'Hauteur min.: %{height}px, Largeur min.: %{width}px',
            format: 'Format accepté: %{format}',
            highlight_image: 'Image en surbrillance',
            highlighted_image: 'Image en surbrillance',
            remove_highlight: 'Supprimer la surbrillance',
            text: 'Cliquez ou faites glisser une image',
        },
    },
    menu: {
        sidebar: {
            assets: 'Assets',
            access_points: 'Points d’accès',
            accounts: 'Comptes',
            account_administration: 'Administration de compte',
            account_details: 'Détails du compte',
            account_yields: 'Céder',
            administrators: 'Administrateurs',
            all_users: 'Tous les utilisateurs',
            'api-keys': 'API keys',
            bookingStats: 'Vos statistiques',
            bookings: 'Vos Réservations',
            campaigns: 'Campagnes',
            content: 'Contenu',
            dashboard: 'Dashboard',
            discounts: 'Réductions',
            internal_yield_service_user: 'Yields',
            invoices: 'Factures',
            legaldocuments: {
                engagement_agreement: 'Accord d’engagement',
                main: 'Documents juridiques',
                privacy_statement: 'Dèclaration de confidentialitè',
                terms_conditions: 'Termes et conditions',
            },
            memberships: 'Adhésions',
            membership_schedules: 'Programmes d’adhésion',
            membership_pools: 'Groupes d’adhésion',
            order_create: 'Faire une Réservation',
            order_create_disallowed: 'Votre compte est inactif. Contacter MOBIAN pour réactiver.',
            points_of_interest: 'Points d’intérêt',
            products: 'Produits',
            product_memberships: 'Adhésion aux produits',
            properties: 'Caractéristiques',
            propertygroups: 'Property groups',
            reservations: 'Réservations',
            settings: 'Réglages',
            subcategories: 'Subcategories',
            subscriptions: 'Abonnements',
            system_administration: 'Administration du système',
            users: 'Utilisateurs',
            webhooks: 'Webhooks',
        },
        topbar: {
            accounts: {
                current: 'Actuelle',
                modal_title: 'Sélectionnez un compte',
                no_account_selected: 'Aucun compte sélectionné',
            },
            security: 'Sécurité',
            profile: 'Profil',
            stop_impersonation: 'Revenir à son log in',
        },
    },
    notifications: {
        access_methods: {
            create: {
                success: 'La méthode d’accès a été ajoutée avec succès',
            },
            delete: {
                success: 'La méthode d’accès a été supprimée avec succès',
            },
            open: {
                success: 'La porte a été ouverte',
            },
            update: {
                success: 'La méthode d’accès a été mise à jour avec succès',
            },
        },
        account_yields: {
            create: {
                success: 'Le rendement utilisateur a été ajouté avec succès',
            },
            delete: {
                success: 'Le rendement de l’utilisateur a été supprimé avec succès',
            },
            update: {
                success: 'Le rendement utilisateur a bien été modifié',
            },
        },
        accounts: {
            create: {
                success: 'Le compte a été ajouté avec succès',
                search_user_limit: 'Seuls les %{count} premiers résultats sont affichés, veuillez affiner davantage vos critères de recherche.',
            },
            update: {
                success: 'Le compte a été modifié avec succès',
            },
        },
        'api-keys': {
            create: {
                success: 'Les API clé ont bien été ajoutés',
            },
            update: {
                success: 'L’API clé a été modifié avec succès',
            },
            delete: {
                success: 'Les API clé ont bien été supprimée',
            },
        },
        bookings: {
            amend: {
                failure: 'La réservation n’a pas été modifiée',
                success: 'La réservation a été modifiée avec succès',
            },
            refund: {
                failure: 'Le remboursement n’a pas été effectué',
                success: 'Le remboursement a été effectué avec succès',
            },
        },
        booking: {
            cancelled: 'La réservation a été annulée avec succès',
        },
        export: {
            failure: 'L’exportation n’a pas pu être envoyée',
            orders: {
                failure: 'L’exportation n’a pas pu être envoyée',
                success: 'L’exportation est envoyée lorsqu’elle est prête',
            },
            success: 'L’exportation est envoyée lorsqu’elle est prête',
        },
        campaigns: {
            create: {
                success: 'La campagne a été ajoutée',
            },
            update: {
                success: 'La campagne a été mise à jour',
            },
            remove: {
                success: 'La campagne a été supprimée',
            },
        },
        current_account: {
            delete: {
                success: 'L’utilisateur a été supprimé de ce compte',
            },
        },
        discounts: {
            create: {
                success: 'La remise a été ajoutée avec succès',
            },
            delete: {
                success: 'La remise a été supprimée avec succès',
            },
            update: {
                success: 'La remise a été modifiée avec succès',
            },
        },
        discount_codes: {
            create: {
                success: 'Le code de réduction a été ajouté avec succès',
            },
            delete: {
                success: 'Le code de réduction a été supprimé avec succès',
            },
            update: {
                success: 'Le code de réduction a été modifié avec succès',
            },
        },
        invitations: {
            created: 'L’invitation a été ajoutée avec succès',
            deleted: 'L’invitation a été supprimée avec succès.',
            accepted: 'L’invitation a été acceptée',
            denied: 'L’invitation a été refusée',
        },
        item: {
            created: 'Bravo ! Correctement créé !',
            updated: 'Le produit a été changé correctement',
        },
        memberships: {
            added: 'L’utilisateur a été ajouté à l’adhésion avec succès',
            delete: {
                success: 'L’utilisateur a été supprimé de l’abonnement',
            },
        },
        orders: {
            cancelled: {
                success: 'Commande annulée',
            },
            retry: {
                success: 'La réservation a été modifiée',
            },
            suspicious: 'Suspicious activity on this booking',
            update: {
                success: 'La réservation a bien changé',
            },
        },
        points_of_interest: {
            create: {
                success: 'Les POI ont bien été ajoutés',
            },
            delete: {
                success: 'Les POI ont bien été supprimée',
            },
            images: {
                create: {
                    success: 'L’image a été ajoutée avec succès',
                },
                delete: {
                    success: 'L’image a été supprimée avec succès',
                },
            },
            import: {
                success: 'Les POI ont été ajoutés avec succès',
            },
            update: {
                success: 'Les POI ont bien été changés',
            },
        },
        products: {
            create: {
                success: 'Le produit a été ajouté avec succès',
            },
            configuration: {
                administration_fee: {
                    maximum: 'Maximum',
                    maximum_placeholder: 'e.g. 1.99, 2.50',
                    minimum: 'Minimum',
                    minimum_placeholder: 'e.g. 1.99, 2.50',
                    percentage: 'Percentage',
                    percentage_placeholder: 'e.g. 0.10 (10%), 0.03 (3%)',
                },
                allow_exceed_capacity_from: 'Capacité autorisée dépassée invalide',
                allow_overstay: 'Dépassement autorisé invalide',
                arrival_dates_blocked: 'Dates d’arrivée bloquées invalides',
                blocked_dates: 'Dates bloquées invalides',
                capacity: 'Capacité invalide',
                departure_dates_blocked: 'Dates de départ bloquées invalides',
                freeze_period: 'Période de gel invalide',
                leeway_arrival: 'Marge d’arrivée invalide',
                leeway_departure: 'Marge de départ invalide',
                maximum_advance: 'Temps maximum anticipé invalide',
                maximum_duration: 'Temps minimum anticipé invalide',
                minimum_advance: 'Temps minimum anticipé invalide',
                minimum_duration: 'Durée invalide',
                number_of_persons: 'Nombre de personnes invalide',
                operational_times: 'Heure (s) opérationnelle (s) non valide (s) uniquement autorisée (s) le jour de la semaine (spécifique ou non spécifique)',
                sales_price: 'Prix de vente invalide',
                split_percentage: 'Pourcentage de prix réparti invalide',
                terms_and_conditions: {
                    name: 'Nom invalide',
                    link: 'URL invalide',
                },
                vat_percentage: 'Pourcentage de TVA invalide',
                voucher_include_invoice: 'Le bon inclut la facture invalide',
            },
            delete: {
                success: 'Le produit a été supprimé avec succès',
            },
            update: {
                success: 'Le produit a changé avec succès',
            },
            failure: 'Produit non supprimée',
            images: {
                create: {
                    success: 'L’image a été ajoutée avec succès',
                },
                delete: {
                    success: 'L’image a été supprimée avec succès',
                },
            },
            localisation: {
                update: {
                    success: 'Les textes ont été mis à jour avec succès',
                },
            },
            logo: {
                create: {
                    failure: 'Une erreur s’est produite lors du téléchargement du logo',
                    success: 'Le logo est téléchargé',
                },
                delete: {
                    failure: 'Une erreur s’est produite lors de la suppression du logo',
                    success: 'Le logo est supprimé',
                },
            },
            property: {
                create: {
                    success: 'La caractéristique a bien été ajoutée',
                },
                delete: {
                    success: 'La caractéristique a bien été supprimée',
                },
                update: {
                    success: 'La caractéristique a bien été modifée',
                },
            },
            related: {
                create: {
                    success: 'Le produit a été attribué',
                },
                delete: {
                    success: 'La relation entre les produits est supprimée',
                },
            },
            resource: {
                available_resources: {
                    failure: 'Une erreur s’est produite lors de la récupération des ressources disponibles',
                },
                update: {
                    success: 'La ressource produit a été modifiée avec succès',
                },
            },
        },
        profile: {
            update: {
                success: 'Le profil a été modifié avec succès.',
            },
        },
        propertygroups: {
            create: {
                success: 'Le groupe de caractéristique a bien été ajouté',
            },
            delete: {
                success: 'Le groupe de caractéristique a bien été supprimé',
            },
            update: {
                success: 'Le groupe de caractéristique a bien été changé',
            },
        },
        properties: {
            create: {
                success: 'Les caractéristiques ont bien été ajoutées',
            },
            delete: {
                success: 'Les caractéristiques ont bien été supprimées',
            },
            update: {
                success: 'Les caractéristiques ont bien été changées',
            },
        },
        subcategories: {
            create: {
                success: 'La sous catégorie a bien été ajoutée',
            },
            delete: {
                success: 'La sous catégorie a bien été supprimée',
            },
            update: {
                success: 'La sous catégorie a bien été modifée',
            },
        },
        subscriptions: {
            create: {
                success: 'L’abonnement a été ajouté avec succès',
            },
            delete: {
                success: 'L’abonnement a été supprimé avec succès',
            },
            update: {
                success: 'L’abonnement a été modifié avec succès',
            },
            confirm: {
                success: 'L’abonnement a été confirmé avec succès',
            },
            terminate: {
                success: 'L’abonnement a été résilié avec succès',
            },
        },
        subscriptionProducts: {
            create: {
                success: 'Le produit d’abonnement a été ajouté avec succès',
            },
            delete: {
                success: 'Le produit d’abonnement a été supprimé avec succès',
            },
        },
        users: {
            create: {
                success: 'L’utilisateur a été ajouté avec succès',
            },
            delete: {
                success: 'L’utilisateur a été supprimé avec succès',
            },
            update: {
                success: 'L’utilisateur a changé avec succès',
            },
            confirmed: {
                success: 'L’utilisateur a été confirmé avec succès',
            },
            password: {
                failure: 'Quelque chose s’est mal passé lors de l’envoi de la demande. Réessayez plus tard.',
                success: 'L’utilisateur sera informé par courrier électronique avec une demande de réinitialisation du mot de passe.',
            },
        },
        user_product_membership: {
            create: {
                success: 'L’adhésion au produit utilisateur a été ajoutée',
            },
            delete: {
                success: 'L’adhésion au produit utilisateur a été supprimée',
            },
            update: {
                success: 'L’adhésion au produit utilisateur a été mise à jour',
            },
        },
        utilities: {
            translate: {
                create: {
                    success: 'Le texte de base a été traduit.',
                },
            },
        },
        yields: {
            delete: {
                success: 'Le yield a bien été annulé',
            },
        },
        webhooks: {
            create: {
                success: 'Le webhook a été ajouté avec succès',
            },
            delete: {
                success: 'Le Webhook a été supprimé avec succès',
            },
            update: {
                success: 'Le webhook a été mis à jour avec succès',
            },
        },
    },
    pages: {
        booking_tool: {
            not_available: {
                text: 'Il semble que la plateforme de MOBIAN ne soit pas valable pour ce compte. Pour plus d’infos, veuillez joindre votre contact chez MOBIAN.',
                title: 'Oh non...',
            },
        },
        create_booking: {
            description: 'Avant de voir notre offre, nous vous demandons de remplir ces champs pour mieux cibler votre recherche',
            form: {
                errors: {
                    destination_arrival_date: 'Date d’arrivée',
                    destination_arrival_time: 'A quelle heure ?',
                    destination_departure_date: 'Date de départ',
                    destination_departure_time: 'A quelle heure ?',
                    destination_google_place_id: 'Destination',
                    number_of_persons: 'Merci d’indiquer le nombre de personnes',
                    one_way: 'Merci d’indiquer le type de voyage que vous souhaitez',
                    origin_google_place_id: 'Merci d’indiquer l’adresse où vous souhaitez être pris en charge',
                },
                fields: {
                    destination_arrival_date: 'Date de votre départ ?',
                    destination_arrival_time: 'A quelle heure ?',
                    destination_departure_date: 'Date de votre retour ?',
                    destination_departure_time: 'A quelle heure ?',
                    destination_google_place_id: 'Votre destination ?',
                    one_way: {
                        retour_trip: 'Voyage aller-retour',
                        single_trip: 'Voyage aller uniquement',
                    },
                    origin_google_place_id: 'Mon adresse',
                    service: {
                        park_and_sleep: 'Se Garer et Dormir à l’hotel',
                        park_and_walk: 'Se Garer et Marcher',
                        public_transport: 'Transport Public',
                        short_long_parking: 'Parking avec navette',
                        taxi: 'Taxi',
                        title: 'Options',
                        valet_parking: 'Service de voiturier',
                    },
                },
            },
            not_available: {
                text: 'Il semble que la plateforme de MOBIAN ne soit pas valable pour ce compte. Pour plus d’infos, veuillez joindre votre contact chez MOBIAN.',
                title: 'Oh non...',
            },
            title: 'Faire une Réservation',
        },
        dashboard: {
            select: 'Sélectionnez votre devise',
            widgets: {
                statistics_card: {
                    bookings: 'Réservations',
                    current_week: 'Cette semaine',
                    last_week: 'La semaine dernière',
                    today: 'Aujourd’hui',
                    week: 'Semaine',
                    yesterday: 'Hier',
                },
                statistics_graph: {
                    current_month: 'Lors des 4 dernières semaines',
                    previous_year: 'l’année dernière',
                    title: 'Réservation',
                },
            },
        },
    },
    resources: {
        access_methods: {
            create: {
                title: 'Créer une méthode d’accès',
            },
            delete: {
                title: 'Supprimer la méthode d’accès',
                description: 'Êtes-vous sûr de vouloir supprimer cette méthode d’accès?',
            },
            edit: {
                title: 'Modifier cette méthode d’accès',
            },
            fields: {
                access_id: 'ID d’accès',
                access_point_access_method_id: 'ID de la méthode d’accès du point d’accès',
                access_point_id: 'ID du point d’accès',
                carpark_id: 'Identifiant de parking',
                connector_id: 'ID du connecteur',
                custom_counter_id: 'ID de compteur personnalisé',
                depot_id: 'Identifiant de dépôt',
                direction: 'Direction',
                door_id: 'ID de la porte',
                enabled: 'Statut',
                gate_id: 'ID de porte',
                is_allowed_for_users: 'Autoriser les utilisateurs',
                location_id: 'ID de localisation',
                name: 'Nom',
                phone: 'Numéro de téléphone',
                phone_country: 'Pays du numéro de téléphone',
                product_id: 'Identifiant du produit',
                station_id: 'ID de la station',
                subscription_id: 'ID d’abonnement',
            },
            list: {
                active: 'Actif',
                direction: 'Direction',
                directions: {
                    1: 'Entrée / Sortie',
                    2: 'Entrer',
                    3: 'Sortie',
                },
                enabled: 'Statut',
                inactive: 'Inactif',
            },
            no_results: 'Aucune méthode d’accès trouvée',
            open: 'Porte ouverte',
            requesting: 'Demander',
            title: 'Méthode d’accès',
        },
        access_points: {
            actions: {
                create: {
                    title: 'Créer une point d’accès',
                },
                edit: {
                    title: 'Modifier le point d’accès: %{title}',
                },
            },
            fields: {
                access_point: 'Choisissez un point d’accès',
                access_method: 'Choisissez une méthode d’accès',
                product: 'Produit',
                title: 'Titre',
                type: 'Type',
            },
            no_results: 'Aucun point d’accès trouvé',
            title: 'Points d’accès',
            types: {
                access: 'Accès',
                on_site: 'Sur place',
            },
        },
        account_yields: {
            actions: {
                create: 'Créer un rendement utilisateur',
                edit: 'Mettre à jour le rendement des utilisateurs',
            },
            fields: {
                accountId: 'Utilisateur',
                yield: 'Yield',
            },
            title: 'Yields',
        },
        accounts: {
            actions: {
                activate: 'Activer',
                create: 'Créer un compte',
                deactivate: 'Désactiver',
                edit: 'Modifier le compte',
            },
            activity: {
                activate: {
                    title: 'Le compte sera activé',
                    description: 'Lorsque le compte est actif, il peut se connecter à nos tableaux de bord, applications et utiliser nos services.',
                },
                deactivate: {
                    title: 'Le compte sera désactivé',
                    description: 'Lorsque le compte est inactif, il ne peut plus se connecter à nos tableaux de bord, applications ou utiliser nos services.',
                },
            },
            fields: {
                address: 'Adresse',
                bic: 'BIC',
                city: 'Ville',
                contact_details: 'Coordonnées de contact',
                contact_email: 'Email',
                contact_emergency_phone: 'Téléphone d’urgence',
                contact_phone: 'Téléphone de contact',
                contact_whatsapp: 'Numéro Whatsapp',
                country: 'Pays',
                email: 'Email',
                iban: 'IBAN',
                is_enabled: 'Actif',
                last_name: 'Nom',
                locale: 'Local',
                name: 'Nom',
                notify_on_cancelled: 'Notifier sur annulation',
                notify_on_created: 'Notifier sur création',
                notify_on_modified: 'Notifier sur modification',
                orders: 'Ordres',
                owner: 'Propriétaire',
                phone: 'Téléphone',
                registration: 'Numéro COC',
                role: 'Rôle',
                vat: 'TVA',
                zipcode: 'Code postal',
            },
            filters: {
                active: {
                    active: 'Seulement actif',
                    inactive: 'Seulement inactif',
                },
            },
            forms: {
                account: 'Compte',
                account_search_user: 'Rechercher un utilisateur',
                account_select_user: 'Sélectionner l’utilisateur',
                address: 'Adresse',
                company: 'Compagnie',
                contact: 'Contacter',
                general: 'Général',
                notifications: 'Préférences de notification par e-mail',
                products: 'Dernière mise à jour des produits',
                registrations: 'Inscriptions',
            },
            name: 'Utilisateur',
            notifications: {
                inactive: 'Cet utilisateur est inactif. Cliquez sur le bouton d’activation pour réactiver l’utilisateur.',
                not_confirmed: 'Cet utilisateur n’a pas encore confirmé son compte.',
            },
            products: {
                actions: {
                    list: 'Afficher tous les produits (%{total})',
                },
            },
            reset_password: {
                description: 'La réinitialisation d’un mot de passe enverra un nouveau mot de passe vers l’e-mail de l’utilisateur. L’ancien mot de passe ne sera plus utilisable. Les sessions actuellement connectées de cet utilisateur devront se connecter sur tous les appareils avec leur nouveau mot de passe.',
                title: 'Réinitialiser le mot de passe des utilisateurs',
            },
            roles: {
                administrator: 'Administrateur',
                provider: 'Fournisseur',
                reseller: 'Revendeur',
            },
            select_user: {
                table: {
                    email: 'Email',
                    name: 'Nom',
                },
            },
            title: 'Utilisateurs',
        },
        'api-keys': {
            acitons: {
                create: 'Créer une API key',
                edit: 'Modifier la clé API',
            },
            error: {
                description: 'La quantité maximale de clés API disponibles a été atteinte. Vous ne pouvez plus créer de clés API. Veuillez en supprimer un avant d’en créer un nouveau.',
                title: 'Oups ...',
            },
            fields: {
                created_at: 'Créé à',
                last_used_at: 'Dernière utilisation',
                name: 'Prénom',
                token: 'Clé',
            },
            modal: {
                description: 'Voici votre nouvelle API key. <strong>C’est la seule fois où le jeton sera affiché. Veillez donc à ne pas le perdre!</strong> Vous pouvez supprimer le jeton à tout moment.',
                title: 'API key pour %{name}',
            },
            title: 'API Keys',
        },
        bookings: {
            actions: {
                edit: 'Réservation: %{name} (%{id})',
            },
            amend: {
                buttons: {
                    paymentInvoice: 'Payez par facture',
                    paymentMethod: 'Sélectionnez le mode de paiement',
                    price: 'Nouveau prix',
                },
                loading: {
                    'price-check-error': 'Un problème est survenu lors de la vérification d’un nouveau prix',
                    'payment-invoice': 'Tentative de paiement par facture',
                    'payment-link': 'Créer un lien de paiement',
                    'payment-not-required': 'Modification des valeurs mises à jour',
                    form: 'Obtenir de nouveaux prix',
                    payments: 'Récupération de tous les modes de paiement',
                    transactions: 'Créer une transaction',
                },
                messages: {
                    amendError: 'Une erreur s’est produite lors de l’enregistrement du formulaire.',
                    'payment-invoice': 'Le paiement est facturable. Vous pouvez enregistrer le formulaire.',
                    'payment-not-required': 'Le paiement n’est pas requis. Vous pouvez enregistrer le formulaire.',
                    'payment-required': 'La différence de prix n’inclut pas les coûts de transaction potentiels.',
                    'price-check-error': 'Un problème est survenu lors de la vérification d’un nouveau prix',
                    availability: 'Ce produit n’est plus disponible.',
                    linkCopied: 'Le lien de paiement est copié',
                },
                prices: {
                    current: 'Prix ​​actuel',
                    difference: 'Différence',
                    new: 'Nouveau prix',
                },
                phase: {
                    paymentLink: 'Votre lien de paiement pour %{title} - %{method}',
                },
                title: 'Modifier la réservation',
            },
            fields: {
                createdAt: 'Créé à',
                customerRemarks: 'Remarques clients',
                destinationArrivalDate: 'Date d’arrivée',
                email: 'email',
                firstName: 'Prénom',
                fullName: 'Nom complet',
                funnelId: 'Campagne',
                lastName: 'Nom de famille',
                licensePlate: 'Plaque d’immatriculation',
                locale: 'Local',
                orderId: 'Numéro de commande',
                phone: 'Téléphone',
                price: 'Prix',
                product: 'Produit',
                resellerId: 'Revendeur',
                status: 'Statut',
            },
            forms: {
                additional: 'Additionnel',
                general: 'Général',
            },
            refund: 'Réservation remboursée',
            title: 'Réservations',
        },
        campaigns: {
            actions: {
                create: 'Créer une campagne',
                edit: 'Mettre à jour cette campagne: %{title}',
            },
            fields: {
                accountId: 'Revendeur',
                id: 'ID',
                identifier: 'identifiant',
                name: 'Nom',
            },
            name: 'Campagne',
            title: 'Campagnes',
            show: {
                api: 'API',
                catalogue: 'Catalogue',
                week: 'Semaine',
                last_week: 'Réservations au cours des dernières semaines',
                week_number: '# de semaine',
                bookings_amount: '# de réservations',
                tabs_title: 'Informations sur l’utilisation du catalogue/API',
                catalogue_p1: 'Vous n’êtes pas prêt pour une intégration API complète, mais vous souhaitez démarrer rapidement et en toute sécurité? L’entonnoir de réservation de MOBIAN peut facilement être utilisé et fonctionne immédiatement après la création d’une campagne. La seule chose que nous avons besoin que vous envoyiez dans votre lien est l’identifiant de votre campagne. Votre identifiant est un jeton unique qui nous permet d’ajouter facilement la réservation à votre compte comme si vous l’avez vendue via votre propre site Web. Nous avons ajouté un exemple ci-dessous:',
                catalogue_p2: 'Vous pouvez ajouter l’identifiant de campagne à n’importe quelle page de l’entonnoir de réservation. De cette façon, vous pouvez toujours laisser votre utilisateur commencer n’importe où dans l’entonnoir et adapter l’expérience à ses besoins.',
                catalogue_p3: 'Dès qu’un utilisateur arrive sur la page à laquelle votre campagne est attachée, il reçoit un marqueur. Ce marqueur s’assure que chaque vente que cette personne fait en la faisant sera sous votre compte. Être conscient; si un utilisateur visite l’entonnoir de réservation avec une nouvelle campagne, cela remplacera le marqueur actif actuel. Les marqueurs ont un temps de recharge de 72 heures, après quoi il sera désactivé. Les réservations effectuées après cette période ne seront pas attachées à votre compte jusqu’à ce qu’elles visitent à nouveau un lien avec votre identifiant.',
                api_p1: 'Agréable! Vous intégrez avec l’API, mais vous souhaitez définir différentes campagnes ou entonnoirs via lesquels vous vendez. Vous pouvez facilement joindre une réservation à la campagne. Pour cela, vous pourriez avoir besoin que votre personnel technique ajuste quelque chose dans les demandes que vous envoyez à notre API. Lorsque vous créez une réservation, vous communiquez déjà beaucoup d’informations et nous ajoutons une autre pièce au puzzle. Dans la documentation, vous trouverez un paramètre appelé funnel_id. Pour cette information sur la pièce, vous devez avoir un ID que vous pouvez entrer.',
                api_p2: 'L’identifiant de cette campagne est:',
                api_p3: 'Une fois les réservations créées avec cet ID, elles seront automatiquement associées à cette campagne.',
            },
        },
        bookingStats: {
            fields: {
                AUD: 'AUD',
                CHF: 'CHF',
                EUR: 'EUR',
                GBP: 'GBP',
                NZD: 'NZD',
                SEK: 'SEK',
                USD: 'USD',
                amount: 'Montant',
                bookings: 'les réservations',
                label: 'Date',
                total: 'Total',
            },
            name: 'Statistiques',
            title: 'Statistiques de réservation',
        },
        discount_codes: {
            actions: {
                create: 'Créez un code de réduction',
                edit: 'Modifier le code de réduction: %{title}',
            },
            components: {
                expiry_date: {
                    placeholder: 'Date d’expiration',
                },
                status: {
                    choices: {
                        unused: 'Inutilisé',
                        used: 'Utilisé',
                    },
                },
                type: {
                    choices: {
                        multi: 'Multi-usage',
                        single: 'Usage unique',
                        wallet: 'Portefeuille',
                    },
                },
            },
            fields: {
                amount: 'Montant',
                amount_used: 'Quantité utilisée',
                currency: 'Monnaie',
                expiry_date: 'Date d’expiration',
                id: 'ID',
                is_enabled: 'Actif',
                last_used_at: 'Dernière utilisation à',
                percentage: 'Pourcentage',
                status: 'Statut',
                token: 'Jeton',
                type: 'Type',
            },
            title: 'Codes de réduction',
        },
        discounts: {
            actions: {
                activate: 'Activer',
                create: 'Créez une réduction',
                deactivate: 'Désactiver',
                edit: 'Modifier la réduction: %{title}',
                list: 'Liste',
            },
            activity: {
                activate: {
                    title: 'Activer',
                    description: 'Êtes-vous sûr de vouloir activer cette réduction?',
                },
                deactivate: {
                    title: 'Désactiver',
                    description: 'Êtes-vous sûr de vouloir désactiver cette réduction?',
                },
            },
            fields: {
                accountId: 'Compte',
                amount: 'Montant',
                apply_on_fees: 'Appliquer aux frais',
                created_at: 'Créé à',
                currency: 'Monnaie',
                end_processing: 'Fine elaborazione',
                expiry_date: 'Date d’expiration',
                id: 'ID',
                is_enabled: 'Actif',
                limit: 'Limite',
                percentage: 'Pourcentage',
                priority: 'Priorité',
                title: 'Titre',
                uses_discount_codes: 'Utilise des codes de réduction',
            },
            forms: {
                account: 'Compte',
                discount_codes: 'Codes de réduction',
                general: 'Général',
                manage_discount_codes: 'Codes de réduction',
            },
            operators: {
                labels: {
                    and: 'Et',
                    equal_or_greater_than: 'Égal ou supérieur à',
                    equal_or_less_than: 'Égal ou inférieur à',
                    equal: 'Est égal',
                    greater_than: 'Supérieur à',
                    less_than: 'Inférieur à',
                    not_equal: 'N’est pas égal à',
                    or: 'Ou',
                    within: 'Au sein',
                },
                title: 'Opérateur',
            },
            placeholders: {
                email_domain: 'par ex. nu.nl',
            },
            rules: {
                appliance: 'Règles d’application',
                condition: 'Règles relatives aux conditions',
                title: 'Règles d’application et de condition',
                no_results: 'Il n’y a pas de %{type}',
            },
            types: {
                global: 'Global',
                regular: 'Régulier',
            },
            title: 'Réductions',
        },
        invitations: {
            actions: {
                accept: {
                    title: 'Accepter les',
                    description: 'Voulez-vous accepter cette invitation ?',
                },
                deny: {
                    title: 'Refuser l’invitation',
                    description: 'Voulez-vous refuser cette invitation ?',
                },
            },
            no_invitations: 'Aucune invitation trouvée.',
            open_invitations: 'Ouvrir des invitations',
            request_title: 'Demandes d’invitations',
            sent_title: 'Invitations envoyées',
            title: 'Invitations',
        },
        invoices: {
            download: 'Télécharger la facture',
            export: {
                success: 'Les factures ont été exportées avec succès.',
                title: 'Exporter des factures',
                lines: {
                    title: 'Exporter les lignes de facture',
                },
            },
            fields: {
                amount: 'Montant',
                invoiced_at: 'Facturé à',
                status: 'État',
            },
            show: {
                details: 'Détails',
                title: 'Afficher la facture',
            },
            status: {
                charged_back: 'Remboursé',
                open: 'Ouvert',
                overdue: 'En retard',
                paid: 'Payé',
                paid_manually: 'Payé manuellement',
                processing: 'Processing',
            },
            title: 'Factures',
        },
        general: {
            fields: {
                boolean: {
                    yes: 'Oui',
                    no: 'Non',
                },
            },
        },
        memberships: {
            actions: {
                edit: 'Modifier l’adhésion: %{title}',
            },
            fields: {
                concurrency: 'Accès simultané',
                purge_reservations: 'Réservations de purge',
                paid_by_invoice: 'Payé par facture',
            },
            messages: {
                created: {
                    success: 'Adhésion créée avec succès',
                },
                deleted: {
                    success: 'Abonnement supprimé avec succès',
                },
                updated: {
                    success: 'Adhésion mise à jour',
                },
            },
        },
        membership_schedules: {
            messages: {
                created: {
                    success: 'Programme d’adhésion créé avec succès',
                },
                deleted: {
                    success: 'Programme d’adhésion supprimé avec succès',
                },
                updated: {
                    success: 'Programme d’adhésion mis à jour avec succès',
                },
            },
        },
        no_account: {
            description: 'Pour pouvoir utiliser le tableau de bord, vous devez être associé à un partenaire. L’un de nos partenaires vous a peut-être déjà envoyé une invitation à rejoindre son compte d’entreprise. Cliquez sur le bouton ci-dessus pour voir si vous avez des invitations ouvertes.',
            title: 'Aucun compte disponible',
        },
        orders: {
            actions: {
                check_new_price: 'Vérifiez le nouveau prix',
                csv: 'CSV',
                export: 'Réservations à l’exportation ',
                export_related: 'Réservations de réservation à l’exportation',
                order_email_resent: 'Order email resent',
                resend_email: 'Renvoyer email',
                retry: 'Recommencez',
            },
            amend: {
                message: {
                    availability: 'Ce produit n’est plus disponible.',
                    payment: {
                        required: 'La différence de prix n’inclut pas les coûts de transaction potentiels.',
                    },
                },
                payment_method: {
                    button: 'Mode de Paiement',
                },
                payment_link: {
                    title: 'Votre lien de paiement pour %{title}:',
                },
                price: {
                    current: 'Ancien prix',
                    new: 'Nouveau prix',
                    difference: 'Différence',
                },
                title: 'Modifier la réservation',
            },
            cancel: {
                description: 'Êtes-vous sûr de vouloir annuler cette réservation?',
                title: 'Annuler la Réservation',
            },
            edit: {
                no_longer_editable: 'Cette information ne peut plus être modifiée dans le système, veuillez contacter directement le fournisseur.',
            },
            fields: {
                cancelled_at: 'Annulé à',
                commission: {
                    int_yield_price: 'Reseller service yield',
                    mobian_commission_total: 'Total',
                    mobian_product_commission_price: 'MOBIAN commission',
                    mobian_product_yield_commission_price: 'Produit yield commission',
                    mobian_vat_amount: 'Commission TVA',
                    mobian_vat_price: 'Total',
                    price_administration_fee: 'Coûts d’administration',
                    price_base: 'Prix de base',
                    price_costfree_cancellation: 'Annulation sans frais',
                    price_options: 'Options',
                    provider_total_price: 'Total intermédiaire',
                    reseller_commission_total: 'Commission du reseller',
                    reseller_product_commission_price: 'Commission du Produit',
                    reseller_product_price: 'Prix total de la résa',
                    reseller_product_yield_commission_price: 'Commission Yield',
                    reseller_vat_amount: 'TVA',
                    reseller_vat_price: 'Total',
                },
                country_code: 'Code postal',
                created_at: 'Créé le',
                customer_remarks: 'Remarques',
                destination_address: 'De',
                destination_arrival_date: {
                    hours: 'Heure',
                    label: 'Date arrivée',
                    minutes: 'Minute',
                },
                destination_departure_date: {
                    hours: 'Heure',
                    label: 'Date départ',
                    minutes: 'Minute',
                },
                drop_off_date: 'Date de début',
                ending_at: 'Fin à',
                email: 'Email',
                first_name: 'Prénom',
                flight_number: 'Numéro de vol',
                full_name: 'Nom',
                campaigns: 'Campagnes',
                is_test: 'Test',
                last_name: 'Nom',
                license_plate: 'Plaque d’immatriculation',
                locale: 'Langue',
                location_address: 'Lieu',
                number_of_persons: 'Nombre de personnes',
                order_id: 'Réservation',
                origin_address: 'À',
                payment_amount_paid: 'Montant payé',
                payment_status: 'Statut du payement',
                phone: 'Téléphone',
                pick_up_date: 'Date de ramassage',
                price: 'Prix',
                product: 'Produit',
                provider: 'Provider',
                reservation_status: 'Situation de la réservation',
                return_flight_number: 'Numéro de vol retour',
                starting_at: 'À partir de',
                status: 'Situation',
                updated_at: 'Dernière mise à jour',
            },
            filters: {
                cancelled_at: {
                    label: 'Annulé à',
                    placeholder: 'Annulé à',
                },
                created_at: {
                    label: 'Créé le',
                    placeholder: 'Créé le',
                },
                currencies: {
                    label: 'Devises',
                },
                destination_address: {
                    label: 'Point de chute',
                },
                destination_arrival_date: {
                    label: 'Date d’arrivée',
                    placeholder: 'Début',
                },
                destination_departure_date: {
                    label: 'Date de départ',
                    placeholder: 'Fin',
                },
                interval: {
                    choices: {
                        day: 'journée',
                        month: 'mois',
                        week: 'semaine',
                        year: 'année',
                    },
                    label: 'Interval',
                },
                is_test_order: {
                    choices: {
                        only_real: 'Validée',
                        only_test: 'Test',
                    },
                    label: 'Réservation Test',
                },
                last_name: 'Nom',
                payment_status: {
                    choices: {
                        chargedback: 'Rétrofacturation',
                        deferred: 'Différé',
                        failed: 'Echoué',
                        in_progress: 'En cours...',
                        refunded: 'Remboursé',
                        success: 'Réussi',
                        unknown: 'Inconnu',
                    },
                    label: 'Situation du Payement',
                },
                origin_address: {
                    label: 'Lieu de ramassage',
                },
                reservation_status: {
                    choices: {
                        canceled: 'Annulée',
                        completed: 'Completée',
                        error: 'Erreur',
                        pending: 'En Attente',
                        split: 'Se Séparer',
                        under_review: 'à l’étude',
                    },
                    label: 'Statut de la réservation',
                },
            },
            information: {
                consumer_communication: 'Ce client ne reçoit pas automatiquement les emails de réservation.',
                multibookings: {
                    split_from: 'This booking belongs to multi-booking ',
                    split_to: 'This booking has been split to ',
                },
                test_booking: 'Cette réservation est créée en tant que commande test.',
            },
            name: 'Réservations',
            paymentSlip: {
                download: {
                    title: 'Télécharger le bulletin de paiement',
                },
                send: {
                    description: 'Le consommateur reçoit un bulletin de paiement contenant chaque mise à jour. Êtes-vous sûr de vouloir envoyer le bulletin de paiement manuellement?',
                    success: 'Bulletin de paiement envoyé avec succès',
                    title: 'Envoyer le bulletin de versement',
                },
                title: 'Bulletin de versement',
            },
            receipt: {
                administration_costs: 'Coûts administratifs',
                administration_fees: 'Frais administratifs',
                base_price: 'Prix de base',
                costfree_cancellation: 'Annulation sans frais',
                membership_deduction: 'Remise pour les membres',
                options: 'Options',
                service_yield: 'Rendement du service',
                split_deduction: 'Split deduction',
                subtotal_additional: 'Sous-total frais supplémentaires',
                subtotal_base: 'Sous-total',
                subtotal_discounts: 'Sous-total remises',
                total: 'Total',
                transaction_fees: 'Coûts de transaction',
            },
            retry: {
                description: 'Are you sure you wish to retry this booking?',
                title: 'Retry Booking',
            },
            show: {
                activities: {
                    booking: {
                        empty: 'Il n’y a pas d’activités enregistrées pour cette réservation.',
                        label: 'Activités',
                        table: {
                            activity: 'Activité',
                            actor: 'Utilisateur',
                            created_at: 'Date',
                            property: 'Valeur',
                            status: 'Statut',
                            target_id: 'Identifiant',
                            target_type: 'Cible',
                        },
                    },
                },
                booking_information: 'Information de réservation',
                paid_on_invoice: 'Cette réservation est payée sur facture.',
                product: 'Produit',
                reseller: 'Revendeur',
                reservation: 'Réservation',
                reservation_details: 'Détails de la réservation',
                travel_details: 'Détails du voyage',
            },
            tabs: {
                activities: 'Activités',
                commission: 'Commission',
                customer: 'Client',
                payment: 'Payement',
                travel: 'Voyage',
            },
            voucher: {
                download: {
                    title: 'Télécharger le bon d’achat',
                },
                send: {
                    description: 'Le consommateur reçoit un voucher pour chaque mise à jour, êtes-vous sûr de vouloir envoyer le voucher manuellement?',
                    success: 'Bon envoyé avec succès!',
                    title: 'Envoyer le Bon',
                },
                after_alteration: {
                    description: 'Souhaitez-vous informer le client des mises à jour?',
                },
                title: 'Bon',
            },
        },
        password: {
            error: {
                password_current: 'Le mot de passe ne correspond pas au mot de passe existant.',
            },
            name: 'changez votre mot de passe',
            fields: {
                password_current: 'Mot de passe actuel',
                password_new: 'Nouveau mot de passe',
                password_confirmation: 'Confirmation du nouveau mot de passe',
            },
            success: 'Le mot de passe a été enregistré avec succès.',
        },
        points_of_interest: {
            actions: {
                create: 'Créer un nouveau point d’intérêt',
                edit: 'Modifier le point d’intérêt: %{title}',
                show: 'Point d’intérêt: %{title}',
            },
            fields: {
                address: 'Adresse',
                city: 'Ville',
                country: 'Pays',
                google_place_id: 'Google Place ID',
                id: 'ID',
                is_highlighted: 'Surligné',
                latitude: 'Latitude',
                location_x: 'Emplacement x',
                location_y: 'Emplacement y',
                longitude: 'Longitude',
                name: 'Nom',
                state: 'Etat',
                street: 'Rue',
                street_number: 'Nº',
                type: 'Type de POI',
                zipcode: 'Code postal',
            },
            import: {
                dropzone: {
                    description: 'Glissez et déposez ou appuyez sur Importez votre fichier CSV avec les nouveaux points d’intérêt.',
                    title: 'Télécharger CSV',
                },
                title: 'Importer des points d’intérêt depuis un fichier CSV',
            },
            promoted_products: {
                add: 'Ajouter un produit sponsorisé',
                no_results: 'Il n’y a aucun produit en promotion',
                title: 'Produits sponsorisés',
            },
            title: 'Points d’interêts',
            types: {
                accommodation: 'Hébergement',
                airport: 'Aéroport',
                beach: 'Plage',
                bridge: 'Pont',
                business_centre: 'Centre d’affaires',
                city: 'Ville',
                cultural: 'Culturel',
                education: 'Éducation',
                event: 'Événement',
                event_center: 'Centre événementiel',
                government_building: 'Bâtiment gouvernemental',
                hospital: 'Hôpital',
                library: 'Bibliothèque',
                museum: 'Musée',
                neighbourhood: 'Quartier',
                other: 'Autre',
                park: 'Parc',
                port: 'Port',
                recreation: 'Des loisirs',
                religious_building: 'Bâtiment religieux',
                restaurant: 'Restaurant',
                shopping_centre: 'Centre commercial',
                sight: 'Point d’intérêt',
                station: 'Gare',
            },
        },
        products: {
            actions: {
                activate: 'Activer',
                create: 'Créer un produit',
                deactivate: 'Désactiver',
                edit: 'Modifier le produit',
                localisation: 'Contenu du produit',
                occupancy: 'L’occupation',
                resource: 'Ressource',
            },
            activity: {
                activate: {
                    title: 'Le produit est activé',
                    description: 'Le produit est désormais rendu visible sur toutes nos plateformes.',
                },
                deactivate: {
                    title: 'Le produit est désactivé',
                    description: 'Le produit n’est pas visible et l’utilisateur final ne verra plus le produit.',
                },
            },
            administration_fee: {
                title: 'Frais d’administration',
            },
            advancedTimes: {
                title: 'Temps avancés maximum et minimum',
                fields: {
                    maximum_advance: 'Temps avancé maximum',
                    minimum_advance: 'Temps avancé minimum',
                },
            },
            allowed_capacity_excess: {
                title: 'Excédent de capacité autorisé',
                fields: {
                    capacity_excess: 'Excédent de capacité',
                },
            },
            attribute: 'Attributs',
            availability: {
                button: 'Valider',
                dialog: {
                    description: '',
                    title: 'Valider le produit',
                },
                results: {
                    arrival_dates_blocked: 'Date d’arrivée bloquée',
                    available_price_information: 'Prix disponible',
                    blocked_dates: 'Dates bloquées',
                    capacity: 'Capacité',
                    configuration: 'Configuration du produit',
                    consumer_price: 'Prix au consommateur',
                    departure_dates_blocked: 'dates de départ bloquées',
                    has_time_zone: 'Fuseau horaire correct',
                    is_visible: 'Produit est visible',
                    maximum_advance: 'Max. Advance',
                    maximum_duration: 'Max. Durée',
                    minimum_advance: 'Le mien. Advance',
                    minimum_duration: 'Min. Duration',
                    operational_times: 'Horaires opérationnels',
                    pricing_service_price: 'Prix du service de tarification',
                    product_enabled: 'Produit actif',
                    provider_enabled: 'Fournisseur actif',
                    provider_price: 'Prix du fournisseur',
                    supported_currency: 'Monnaie prise en charge',
                    supported_resource: 'Paramètres de ressources corrects',
                    valid_price: 'Prix valable',
                },
            },
            arrival_dates_blocked: {
                title: 'Arrivée bloquée',
                add: 'Ajouter une arrivée bloquée',
                no_result: 'Aucune date d’arrivée bloquée n’a été trouvée',
            },
            blocked_dates: {
                title: 'Dates bloquées',
                add: 'Ajouter une date bloquée',
                no_result: 'Aucune date bloquée n’a été trouvée',
            },
            capacity: {
                title: 'Capacité',
            },
            configuration: {
                saved: 'La configuration du produit a été enregistrée avec succès.',
            },
            count: 'Comte',
            departure_dates_blocked: {
                title: 'Dates de départ bloquées',
                add: 'Ajouter des dates bloquées',
                no_result: 'Aucune date de départ bloquée n’a été trouvée',
            },
            duration: {
                no_duration: 'Aucune durée maximale ou minimale n’a été trouvée pour ce produit.',
                fields: {
                    maximum_duration: 'Durée maximale',
                    minimum_duration: 'Durée minimale',
                },
                placeholders: {
                    duration: 'par ex. 10j ou 12h',
                    duration_day: 'par ex. 10j',
                    duration_hour: 'par ex. 12h',
                },
                response: {
                    save: 'Les durées ont été enregistrées avec succès',
                },
            },
            edit: {
                location: 'Modifier l’emplacement',
                resource: 'Modifier la ressource',
            },
            fields: {
                active: 'actif',
                administration_fee: {
                    maximum: 'Maximum',
                    maximum_placeholder: 'p.ex. 1.99, 2.50',
                    minimum: 'Minimum',
                    minimum_placeholder: 'p.ex. 1.99, 2.50',
                    percentage: 'Pourcentage',
                    percentage_placeholder: 'p.ex. 0.10 (10%), 0.03 (3%)',
                },
                allow_overstay: 'Autoriser le dépassement',
                category_id: 'Category',
                city: 'Ville',
                communicate_email_addresses: 'Communiquer les adresses e-mail',
                company_id: 'Provider',
                conditionz: 'Termes & Conditions',
                configuration: 'Configuration',
                country_code: 'Code postal',
                country: 'Pays',
                date: 'Date',
                description_de: 'Description Allemande',
                description_en: 'Description Anglaise',
                description_es: 'Description en Espagnol',
                description_fr: 'Description Française',
                description_it: 'Description Italienne',
                description: 'Description Néerlandaise',
                duration: 'Durée maximale et minimale',
                email_domain: 'Domaine de email',
                email_from: 'Envoyer un email depuis',
                email1: 'Email du provider',
                email2: 'Email de l’admin',
                enabled: 'Actif',
                freeze_period: 'Période de gel',
                from: 'De',
                icon: 'Icon',
                id: 'Id',
                inactive: 'Inactif',
                internal_qr_code: 'Code QR interne',
                is_combined: 'Produit combiné',
                is_official_facility: 'Produit officiel',
                is_visible: 'Visible',
                key: 'Clé',
                leeway: 'Marge d’arrivée et de départ',
                location_address: 'Adresse',
                location_id: 'ID du localisation',
                location_latitude: 'Latitude',
                location_longitude: 'Longitude',
                logo: 'Logo',
                mail_de: 'Email écrit en Allemand',
                mail_en: 'Email écrit en Anglais',
                mail_fr: 'Email écrit en Français',
                mail: 'Email écrit en NL',
                map_image: 'Images du produit',
                number_of_persons: 'Nombre de personnes',
                operational_times: 'Heures de fonctionnement',
                options: 'Options',
                parking_id: 'ID du Parking',
                phone: 'Téléphone',
                point_of_interest_id: 'Point of interest',
                priority: 'Priority',
                product_id: 'Provider',
                property_id: 'Propriété',
                provider_id: 'Provider',
                radius: 'Rayon',
                rating: 'Évaluation',
                resource: {
                    id: 'ID de la Ressource',
                    name: 'Nom de la Ressource',
                },
                service_id: 'Service',
                split_percentage: 'Pourcentage de prix réparti',
                street: 'Rue',
                subcategory_id: 'Subcategory',
                terms_and_conditions: {
                    title: 'Conditions générales',
                    link: 'URL',
                    link_placeholder: 'Entrez l’URL',
                    name: 'Nom',
                    name_placeholder: 'Entrez le nom',
                },
                title: 'Titre',
                to: 'À',
                type: 'Type',
                updated_at: 'Mis à jour à',
                value: 'Valeur',
                vat_percentage: 'Pourcentage de TVA',
                voucher_include_invoice: 'Bon inclut la facture',
                weekday: 'Jour de la semaine',
                zipcode: 'Code postal',
            },
            filters: {
                radius: {
                    '5': '5km',
                    '10': '10km',
                    '15': '15km',
                    '20': '20km',
                    '25': '25km',
                },
            },
            forms: {
                access_methods: 'Méthodes d’accès',
                content: 'Contenu',
                general: 'Général',
                location: 'Emplacement',
                logo: 'Logo',
                preferences: 'Préférences',
                properties: 'Propriétés',
                provider: 'Fournisseur',
                related: 'En relation',
            },
            freeze_period: {
                placeholder: 'par exemple, 2h',
            },
            leeway: {
                fields: {
                    leeway_arrival: 'La marge d’arrivée',
                    leeway_departure: 'Marge de départ',
                },
                placeholders: {
                    leeway: 'par exemple 30 (min)',
                },
            },
            logo: {
                description: 'Max 300px haut, Max 300px large',
            },
            name: 'Produit',
            notifications: {
                configuration: 'Il manque des configurations à ce produit. Accédez à la page de configuration pour ajuster la configuration du produit.',
                inactive: 'Ce produit est inactif. Cliquez sur le bouton d’activation pour activer le produit.',
                product_missing_data: 'Il manque des données de configuration et/ou de ressources pour ce produit. Veuillez fournir les données, puis réessayez d’activer le produit.',
                'product-missing-data-for-enable': 'Il manque des données de configuration et/ou de ressources pour ce produit.',
                resource: 'Il manque une ressource pour ce produit. Accédez à la page des ressources pour ajuster le produit/ressource.',
                vat_percentage: 'Il manque un pourcentage de TVA appliqué à ce produit dans les configurations du produit. Rendez-vous sur la page de configuration pour ajuster le pourcentage de TVA.',
            },
            number_of_persons: {
                placeholder: 'Nombre maximum de personnes',
            },
            operational_times: {
                add: 'Ajouter du temps de fonctionnement',
                no_result: 'Il n’y a pas de temps de fonctionnement dans ce produit.',
                save: 'Économisez des temps de fonctionnement',
                title: 'Heures de fonctionnement',
            },
            occupancy: {
                graph: {
                    label: {
                        capacity: 'Capacité',
                        hour: {
                            capacity: 'Capacité par heure',
                            occupancy: 'Occupation par heure',
                        },
                        occupancy: 'L’occupation',
                    },
                    no_results: 'Aucun produit n’est réservé à la date sélectionnée.',
                    title: 'L’occupation',
                },
                reservations: {
                    destination_arrival_date: {
                        no_results: 'Aucune réservation d’arrivée n’a été trouvée pour la date sélectionnée.',
                        title: 'Réservations à l’arrivée (%{count})',
                    },
                    destination_departure_date: {
                        no_results: 'Aucune réservation de départ n’a été trouvée pour la date sélectionnée.',
                        title: 'Réservations de départ (%{count})',
                    },
                    id: {
                        no_results: 'Aucune autre réservation n’a été trouvée pour la date sélectionnée.',
                        title: 'Autres réservations %{count})',
                    },
                },
            },
            title: 'Produits',
            properties: {
                no_results: 'Aucune propriété n’a été ajoutée à ce produit.',
            },
            related: {
                add: 'Ajouter un produit connexe',
                delete: {
                    description: 'L’élément sera supprimé définitivement. Cette action ne peut pas être annulée.',
                    title: 'Êtes-vous sûr de vouloir supprimer ceci?',
                },
                no_results: 'Il n’y a pas de produits associés',
                title: 'en relation',
            },
            require_one_of: {
                add: 'Ajouter un produit lié requis',
                no_result: 'Il n’y a pas de produits liés requis',
                title: 'Exiger un parmi',
            },
            rules: 'Règles',
            sales_price: {
                add: 'Ajouter un bien au prix de vente',
                no_result: 'Il n’y a aucune configuration de prix de vente',
                title: 'Prix de vente',
            },
            pages: {
                location: 'Modifier l’emplacement: %{title}',
                resource: 'Modifier la ressource: %{title}',
            },
            value: {
                add: 'Add a %{type}',
                label: 'Value',
                no_result: 'Il n’y a pas de %{type} dans cette configuration.',
                save: 'Sauvegarder la %{type}',
                title: 'Val',
                types: {
                    dates: {
                        plural: 'dates',
                        singular: 'date',
                    },
                    email_domain: {
                        plural: 'Domaines de email',
                        singular: 'Domaine de email',
                    },
                    time: {
                        plural: 'fois',
                        singular: 'temps',
                    },
                },
            },
            communicate_email_addresses: {
                placeholder: 'Choisissez si les adresses e-mail doivent être communiquées',
                choices: {
                    do_not_send: 'Ne pas envoyer',
                    send: 'Envoyer',
                    send_masked: 'Envoyer masqué',
                },
            },
            voucher_include_invoice: {
                placeholder: 'p. ej. oui ou non',
            },
        },
        product_memberships: {
            actions: {
                create: 'Créer une adhésion de produit',
                edit: 'Modifier l’adhésion de produit',
            },
            create: {
                pricing: 'Nous utiliserons le prix par défaut de l\'adhésion au produit si vous ne mettez pas à jour le champ de prix.',
            },
            fields: {
                group_identifier: 'Identifiant de groupe',
                membership_schedule: 'Horaire',
                price_ondemand: 'Prix à la demande',
                price_scheduled: 'Prix programmé',
                product_membership_id: 'Adhésion au produit',
                supports_ondemand: 'Supporte la demande',
                supports_scheduled: 'Prend en charge la programmation',
                user_product_membership_pool_id: 'Groupe d’adhésion',
                user_vehicle_id: 'Véhicule',
                deferred: 'Différé',
                payment_method_description: 'Par défaut, le mode de paiement est défini sur Facture. Si vous souhaitez utiliser le paiement différé, veuillez cocher la case ci-dessous.',
            },
            no_results: 'Il n’y a pas d’adhésions au produit',
            title: 'Adhésions aux produits',
        },
        profile: {
            name: 'Profil',
        },
        properties: {
            actions: {
                create: 'Créer une propriété',
                edit: 'Modifier la propriété',
                show: 'Propriété: %{title}',
            },
            fields: {
                icon: 'Icône',
                name: 'Nom',
                priority: 'Priorité',
                property_group_id: 'Le groupe de caractéristique',
            },
            languages: {
                label: 'Sélectionner une langue disponible',
            },
            title: 'Caractéristiques',
            validate: {
                property_group_id: 'Remplir un type de caractéristiques',
                'property-groups-not-available': 'Ce type de caractéristiques n’existe pas.',
            },
        },
        propertygroups: {
            actions: {
                create: 'Créer un groupe de propriétés',
                edit: 'Modifier le groupe de propriétés: %{title}',
                show: 'Groupe de propriétés: %{title}',
            },
            fields: {
                id: 'ID',
                name: 'Nom',
                properties: 'Caractéristiques',
                property: 'Caractéristique',
            },
            languages: {
                label: 'Sélectionner une langue disponible',
            },
            name: 'Le groupe de caractéristique',
            plural: 'Les groupes de caractéristique',
        },
        reservations: {
            fields: {
                booking_order_id: 'ID MOBIAN du client',
                cancelled_at: 'Annulé à',
                created_at: 'Créé',
                customer: 'Client',
                customer_remarks: 'Remarques du client',
                destination_address: 'Point de chute',
                destination_arrival_date: 'Date d’arrivée',
                destination_departure_date: 'Date de départ',
                drop_off_date: 'Date de restitution',
                ending_at: 'Fin à',
                flight_number: 'Numéro de vol',
                full_name: 'Nom',
                internal_order_id: 'numéro de commande',
                last_name: 'Nom de famille',
                license_plate: 'Plaque d’immatriculation',
                number_of_persons: 'Nombre de personnes',
                origin_address: 'Lieu de ramassage',
                phone: 'Téléphone',
                pick_up_date: 'Date de ramassage',
                product: 'Produit',
                remote_reference: 'Référence à distance',
                return_flight_number: 'Numéro de vol de retour',
                starting_at: 'À partir de',
                subscription_id: 'ID d’abonnement',
                subscription_reservation_id: 'ID de reservation d’abonnement',
                updated_at: 'Dernière mise à jour',
            },
            name: 'Réservation',
            open_barrier: {
                modal: {
                    error: 'Oups, une erreur s’est produite lors de l’ouverture de la barrière. Veuillez réessayer plus tard.',
                    force_not_allowed_for_access_method: 'La barrière n’est pas autorisée pour cette méthode d’accès.',
                    session_open_barrier_requires_access_point: 'L’ouverture de la barrière dans cette session nécessite un point d’accès.',
                    success: 'La barrière a été ouverte avec succès.',
                },
                title: 'Ouvrir la barrière',
            },
            title: 'Réservations',
            session: {
                asset_not_usable: {
                    description: 'Vous pouvez réessayer avec un arrêt forcé. Cela mettra toujours fin à la session et remettra l’actif à « disponible » si la session a été démarrée avec un actif.',
                    title: 'L’arrêt de la session a échoué en raison des prérequis suivants :',
                },
                button: {
                    end: 'Arrêtez la session',
                    start: 'Démarrez la session',
                    open_barrier: 'Ouvrir la barrière',
                },
                modal: {
                    button: {
                        submit: {
                            end: 'Arrêtez la session',
                            start: 'Démarrez la session',
                        },
                    },
                    callback: {
                        end: {
                            error: 'Oups, une erreur s’est produite lors de la fin de la session. Veuillez réessayer plus tard',
                            success: 'La session s’est terminée avec succès.',
                        },
                        start: {
                            error: 'Oups, une erreur s’est produite lors du démarrage de la session. Veuillez réessayer plus tard',
                            success: 'La session a démarré avec succès.',
                        },
                    },
                    checkbox: 'Ouvre la porte',
                    description: {
                        end: 'La session de réservation en cours a déjà commencé. Cochez la case si vous souhaitez ouvrir ou fermer le portail.',
                        start: 'La session de réservation en cours n’a pas encore démarré. Cochez la case si vous souhaitez ouvrir ou fermer le portail.',
                    },
                    title: {
                        end: 'Arrêtez la session',
                        start: 'Démarrez la session',
                    },
                },
            },
            show: {
                activities: {
                    access_sessions: {
                        title: 'Accès-sessions',
                        not_found: 'Aucune activité de session d’accès n’a été trouvée pour cette réservation',
                    },
                },
                booking_information: 'Informations de réservation',
                product: 'Produit',
                reservation_details: 'Détails de la réservation',
                reservation_price: 'Prix de la réservation',
                travel_details: 'Détails du voyage',
            },
        },
        subcategories: {
            actions: {
                create: 'Créer une sous-catégorie',
                edit: 'Modifier la sous-catégorie',
                show: 'Sous-catégorie: %{title}',
            },
            fields: {
                id: 'ID',
                name: 'nom',
                category_id: 'catégorie',
            },
            languages: {
                label: 'Sélectionner une langue disponible',
            },
            title: 'Sous catégories',
            validate: {
                'categories-not-available': 'Il n’y a pas de catégories disponibles.',
            },
        },
        subscriptions: {
            actions: {
                create: 'Créer',
                edit: 'Modifier',
            },
            fields: {
                account: 'Compte',
                company_name: 'Nom de la société',
                currency: 'Monnaie',
                email: 'Email',
                end_date: 'Date de fin',
                first_name: 'Prénom',
                full_name: 'Nom complet',
                last_name: 'Nom de famille',
                language: 'Langue',
                license_plate: 'Plaque d’immatriculation',
                name: 'Nom',
                order_id: 'Numéro de commande',
                phone: 'Téléphone',
                price: 'Prix',
                start_date: 'Date de début',
                status: 'Statut',
                terminated_at: 'Terminé à',
            },
            show: {
                subscription_details: 'Détails de l’abonnement',
                subscription: 'Abonnement',
            },
            tooltips: {
                ok: 'D’accord',
                pending: 'Abonnement: en attente',
                under_review: 'Abonnement: en cours de révision',
            },
            title: 'Abonnements',
        },
        subscriptionProducts: {
            create: {
                title: 'Ajouter un produit d’abonnement',
            },
            fields: {
                end_time: 'Heure de fin',
                start_time: 'Heure de début',
                day: 'Jour',
                product: 'Produit',
            },
            input: {
                day: {
                    1: 'Lundi',
                    2: 'Mardi',
                    3: 'Mercredi',
                    4: 'Jeudi',
                    5: 'Vendredi',
                    6: 'Samedi',
                    7: 'Dimanche',
                },
            },
            no_results: 'Aucun produit d’abonnement n’a été trouvé.',
            title: 'Produits d’abonnement',
        },
        users: {
            actions: {
                activate: 'Activer',
                create: 'Créer un utilisateur',
                deactivate: 'Désactiver',
                edit: 'Modifier l’utilisateur',
                reset_password: 'Réinitialiser le mot de passe',
            },
            activity: {
                activate: {
                    title: 'L’utilisateur sera activé',
                    description: 'Lorsque l’utilisateur est actif, il peut se connecter à nos tableaux de bord, applications et utiliser nos services.',
                },
                deactivate: {
                    title: 'L’utilisateur sera désactivé',
                    description: 'Lorsque l’utilisateur est inactif, il ne peut plus se connecter à nos tableaux de bord, applications ou utiliser nos services.',
                },
            },
            delete: {
                warnings: {
                    'user-has-active-memberships': 'Des adhésions actives existent pour cet utilisateur.',
                    'user-has-active-subscriptions': 'Des abonnements actifs existent pour cet utilisateur.',
                    'user-has-future-bookings': 'Des réservations futures existent pour cet utilisateur.',
                    'user-has-invoicable-bookings': 'Des réservations facturables existent pour cet utilisateur.',
                    'user-has-open-invoices': 'Des factures ouvertes existent pour cet utilisateur.',
                    'user-has-overdue-invoices': 'Des factures en retard existent pour cet utilisateur.',
                    'user-has-recent-recurring-payment-activity': 'Une activité récente de paiement récurrent existe pour cet utilisateur.',
                    'user-has-wallet-funds': 'Des fonds de portefeuille sont applicables pour cet utilisateur.',
                },
            },
            fields: {
                active: 'Actif',
                address: 'Adresse',
                bic: 'BIC',
                city: 'Ville',
                company_email: 'Courriel de l’entreprise',
                company_name: 'Nom de la compagnie',
                company_registration: 'Numéro COC',
                company_vat: 'Numéro de TVA',
                contract: 'Contrat',
                country: 'Pays',
                email: 'Email',
                external_yield: 'Rendement externe',
                firstname: 'Prénom',
                iban: 'IBAN',
                lastname: 'Nom de famille',
                locale: 'Local',
                logo: 'Logo',
                membership_id: 'Adhésion',
                name: 'Nom',
                orders: 'Ordres',
                phonenumber: 'Téléphone',
                product_commission_reseller: 'Commission produit revendeur',
                provider_id: 'Fournisseur',
                reseller_id: 'Revendeur',
                role: 'Rôle',
                title: 'Titre',
                url: 'URL',
                user_id: 'Revendeur',
                username: 'Nom d’utilisateur',
                vat: 'TVA',
                yield_commission: 'Commission de rendement',
                zipcode: 'Code postal',
            },
            filters: {
                active: {
                    active: 'Seulement actif',
                    inactive: 'Seulement inactif',
                },
            },
            forms: {
                account: 'Compte',
                address: 'Adresse',
                company: 'Compagnie',
                contact: 'Contact',
                general: 'Général',
                products: 'Dernière mise à jour des produits',
                registrations: 'Inscriptions',
            },
            memberships: {
                create: 'Création d’une adhésion utilisateur',
                edit: 'Modifier l’adhésion de l’utilisateur (%{name})',
                no_results: 'Il n’y a aucune adhésion liée à cet utilisateur',
                pricing: 'Prezzi',
            },
            name: 'Utilisateur',
            no_results: 'Aucun utilisateur n’a été trouvé.',
            not_found: 'Aucun utilisateur trouvé.',
            notifications: {
                inactive: 'Cet utilisateur est inactif. Cliquez sur le bouton d’activation pour réactiver l’utilisateur.',
                not_confirmed: 'Cet utilisateur n’a pas encore confirmé son compte.',
            },
            title: 'Utilisateurs',
            products: {
                actions: {
                    list: 'Afficher tous les produits (%{total})',
                },
            },
            // User-product-memberships create and edit
            product_memberships: {
                actions: {
                    create: 'Créer une adhésion au produit utilisateur',
                    edit: 'Modifier l’adhésion au produit utilisateur',
                },
            },
            reset_password: {
                description: 'La réinitialisation d’un mot de passe enverra un nouveau mot de passe vers l’e-mail de l’utilisateur. L’ancien mot de passe ne sera plus utilisable. Les sessions actuellement connectées de cet utilisateur devront se connecter sur tous les appareils avec leur nouveau mot de passe.',
                title: 'Réinitialiser le mot de passe des utilisateurs',
            },
            roles: {
                reseller: 'Revendeur',
                provider: 'Fournisseur',
            },
        },
        wallets: {
            fields: {
                amount: 'Montant',
                balance: 'Solde',
                reason: 'Motif',
                type: 'Type',
            },
            no_results: 'Aucun portefeuille n’a été trouvé.',
            title: 'Portefeuilles',
            topup: {
                notifications: {
                    success: {
                        decrease: 'Le portefeuille de l’utilisateur a été réduit avec succès.',
                        increase: 'Le portefeuille de l’utilisateur a été augmenté avec succès.',
                    },
                },
                label: 'Rechargez',
                title: 'Recharge du portefeuille',
            },
        },
        webhooks: {
            actions: {
                create: 'Créer un Webhook',
                edit: 'Modifier Webhook: %{title}',
            },
            fields: {
                action_booking_cancelled: 'Action Réservation Annulée',
                action_booking_created: 'Action Réservation Créée',
                action_booking_initialised: 'Action Réservation Initialisée',
                action_booking_modified: 'Action Réservation Modifiée',
                action_booking_under_review: 'Action Réservation À L’étude',
                action_reservation_cancelled: 'Action Réservation Annulée',
                action_reservation_created: 'Action Réservation Créée',
                action_reservation_modified: 'Action Réservation Modifiée',
                is_active: 'Actif',
                name: 'nom',
                url: 'url',
            },
            forms: {
                actions: 'actions',
                general: 'Général',
            },
            title: 'Webhooks',
        },
    },
    page: {
        page_not_found: {
            title: 'Page non trouvée',
            description: 'La page que vous recherchez est introuvable.',
        },
        resource_not_found: {
            description: 'Nous n’avons pas pu trouver la ressource que vous recherchez.',
            title: 'Ressource introuvable',
        },
        not_authorised: {
            title: 'Oops..',
            description: 'Il semble que vous ne soyez pas autorisé à voir cette page.',
        },
    },
    release: {
        list: {
            description: 'Dans cette version, nous avons mis à jour les visuels des pages de listes. Nous avons supprimé le bouton Afficher et rendu possible de survoler et de cliquer sur la ligne à rediriger vers la page de détail de cet élément spécifique.',
            title: 'Petite mise à jour de nos pages de présentation',
        },
    },
    signUp: {
        errors: {
            passowrd_chars: 'Le mot de passe doit contenir au moins 6 caractères',
            same_email: 'Les e-mails doivent être égaux',
            same_password: 'Les mots de passe doivent être égaux',
        },
        fields: {
            confirm_email: 'Confirmer l’e-mail',
            confirm_password: 'Confirmez le mot',
        },
        no_account: 'Je n’ai pas de compte',
        title: 'S’inscrire',
        success: 'L’utilisateur a été enregistré avec succès',
    },
};



// WEBPACK FOOTER //
// ./src/i18n/fr.js